import { render, staticRenderFns } from "./DocumentManager.vue?vue&type=template&id=a66a8ade&scoped=true"
import script from "./DocumentManager.vue?vue&type=script&lang=js"
export * from "./DocumentManager.vue?vue&type=script&lang=js"
import style0 from "./DocumentManager.vue?vue&type=style&index=0&id=a66a8ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66a8ade",
  null
  
)

export default component.exports